import classnames from 'classnames/bind';

import { colorDetect } from '@autopass-web/domain';

import NavTop from '../../components/nav-top';
import styles from './index.module.sass';
const cx = classnames.bind(styles);

// navTop
// {
//   title,
//   back
//   onClick
//   event,
// }

const CommonLayout = ({
  className = '',
  navTop = null,
  backgroundColor = '#f1f1f6',
  children,
  fullContent = false,
  bodyStyle = {},
}) => {
  const commonClass = cx({
    common: true,
    'full-content': fullContent,
  });
  const viewHeight = parseInt(
    getComputedStyle(document.documentElement)
      .getPropertyValue('--viewHeight')
      .replace('px', ''),
  );

  return (
    <div
      className={`${commonClass} ${className}`}
      style={{ background: backgroundColor }}
    >
      {navTop && (
        <NavTop
          back={navTop.back}
          title={navTop.title}
          theme={navTop.theme || colorDetect(backgroundColor)}
          rightContent={navTop.rightContent}
          onClick={navTop.onClick}
          event={navTop.event}
          background={backgroundColor}
        />
      )}
      <div
        className={styles.body}
        style={{
          ...bodyStyle,
          height: navTop ? `calc(${viewHeight}px - 65px)` : '100vh',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default CommonLayout;
